define('paramsObserver',['searchParams', 'getCounts', 'getResults'], function (searchParams, getCounts, getResults) {
  'use strict';

  let isLoadingMoreResults = false;
  let searchParamsChanged = {};
  let subscribers = {};
  let temporalSearchParameters = {};

  function removeSubscriber(eventName, callback) {
    if (subscribers && subscribers[eventName]) {
      subscribers[eventName].pop(callback);
    }
  }

  function addSubscriber(eventName, callback) {
    if (!Array.isArray(subscribers[eventName])) {
      subscribers[eventName] = [];
    }

    if (subscribers[eventName].indexOf(callback) === -1) {
      subscribers[eventName].push(callback);
    }
  }

  function fireSubscribers(eventName, response) {
    if (!Array.isArray(subscribers[eventName])) {
      return;
    }

    const totalCallbacks = subscribers[eventName].length;

    for (let i = 0; i < totalCallbacks; i += 1) {
      const fn = subscribers[eventName][i];

      if (typeof fn === 'function') {
        fn(response);
      }
    }
  }

  function publish(value) {
    const response = {
      data: value.response,
      isMoreResults: isLoadingMoreResults,
      parameters: searchParams.get(),
      parametersChanged: searchParamsChanged
    };

    const subscribersToFire = value.subscribers || [];
    const totalSubscribersToFire = subscribersToFire.length;

    for (let index = 0; index < totalSubscribersToFire; index += 1) {
      fireSubscribers(subscribersToFire[index], response);
    }
  }

  function commitChanges() {
    const totalParametersChanged = Object.keys(temporalSearchParameters).length;

    if (totalParametersChanged === 0) {
      return;
    }

    isLoadingMoreResults =
      totalParametersChanged === 1 &&
      Object.prototype.hasOwnProperty.call(temporalSearchParameters, 'PageNumber');

    const beforeResultsLoadData = {
      isMoreResults: isLoadingMoreResults,
      parametersChanged: temporalSearchParameters
    };
    fireSubscribers('beforeSetParams', beforeResultsLoadData);
    searchParams.set(temporalSearchParameters);
    fireSubscribers('beforeResultsLoad', beforeResultsLoadData);
    searchParamsChanged = Object.assign({}, temporalSearchParameters);
    temporalSearchParameters = {};
    getResults.get(searchParams.get(), publish);
  }

  function discardChanges() {
    fireSubscribers('parametersDiscarded');
    temporalSearchParameters = {};
  }

  function getChangesLength() {
    return Object.keys(temporalSearchParameters).length;
  }

  function getCurrentParameters() {
    return searchParams.get();
  }

  function getValueByKey(key) {
    const parameters = Object.assign({}, searchParams.get(), temporalSearchParameters);
    return parameters[key];
  }

  function hasFiltersActive() {
    const defaultParams = searchParams.default();
    const current = searchParams.get();

    for (let key in defaultParams) {
      if (!defaultParams.hasOwnProperty(key)) {
        continue;
      }

      if (typeof defaultParams[key] === 'object' && JSON.stringify(defaultParams[key]) === JSON.stringify(current[key])) {
        continue;
      }

      let currentValue = current[key] || false;
      let defaultValue = defaultParams[key] || false;

      if (defaultValue !== currentValue) {
        return true;
      }
    }

    return false;
  }

  function previewChanges() {
    fireSubscribers('beforeSetParams');
    let previewParameters = Object.assign({}, temporalSearchParameters);
    previewParameters = Object.assign(searchParams.get(), previewParameters);
    searchParamsChanged = Object.assign({}, temporalSearchParameters);
    isLoadingMoreResults = false;
    getCounts.get(previewParameters, publish);
  }

  function setValueByKey(key, value) {
    if (temporalSearchParameters[key] === value) {
      return;
    }

    if (searchParams.getByKey(key) === value && temporalSearchParameters[key] !== value) {
      delete temporalSearchParameters[key];
      return;
    }

    if (searchParams.getByKey(key) === value) {
      return;
    }

    temporalSearchParameters[key] = value;
  }

  function setValues(parameters) {
    if (!parameters) {
      return;
    }

    const keysToExtend = Object.keys(parameters);

    // Do not use object.assign here,
    // as we only want to have temporalSearchParameters that differs from the current searchParams

    for (let i = 0; i < keysToExtend.length; i += 1) {
      const currentKey = keysToExtend[i];
      const value = parameters[currentKey];
      setValueByKey(currentKey, value);
    }
  }

  function resetParameters() {
    const defaultParams = searchParams.default();

    setValues(defaultParams);
    fireSubscribers('resetInProgress', defaultParams);
    commitChanges();
  }

  function getUniqueParameters() {
    return searchParams.uniqueDefaultParams();
  }

  return {
    commit: commitChanges,
    discard: discardChanges,
    getParameter: getValueByKey,
    getParameters: getCurrentParameters,
    hasFilters: hasFiltersActive,
    preview: previewChanges,
    reset: resetParameters,
    setParameter: setValueByKey,
    setParameters: setValues,
    subscribe: addSubscriber,
    unsubscribe: removeSubscriber,
    totalChanges: getChangesLength,
    getUniqueParameters: getUniqueParameters
  };
});

